import variant from "@styled-system/variant";

const buttonStyle = variant({
  scale: "buttonStyles",
});

const buttonSize = variant({
  prop: "size",
  scale: "buttonSizes",
});

const colorStyle = variant({
  prop: "colors",
  scale: "colorStyles",
});

const alertStyle = variant({
  scale: "alertStyles",
});

const badgeColors = variant({
  prop: "colors",
  scale: "badgeColors",
});

const badgeStyles = variant({
  scale: "badgeStyles",
});

const progressBarStyles = variant({
  prop: "colors",
  scale: "progressBarStyles",
});

const modalSize = variant({
  prop: "size",
  scale: "modalSizes",
});

const panelStyle = variant({
  scale: "panelStyles",
});

export {
  buttonStyle,
  buttonSize,
  colorStyle,
  alertStyle,
  badgeColors,
  badgeStyles,
  progressBarStyles,
  modalSize,
  panelStyle,
};
